// import React, { useState, useEffect } from 'react';


// const Notes = ({ LeadId, accessToken , userDetails }) => {
//   const [notes, setNotes] = useState([]);
//   const [newNote, setNewNote] = useState('');

//   useEffect(() => {
//     fetchNotes();
//   }, [LeadId, userDetails]);

//   const fetchNotes = async () => {
//     try {
//       const response = await fetch('https://salesjet-10097049716.catalystappsail.com/leadsnotes', {
//         method: 'GET',
//         headers: {
//           'Authorization': `Bearer ${accessToken}`,
//           'Content-Type': 'application/json',
//           'LeadACVLRecordID': LeadId,
//         },
//       });
//       const data = await response.json();
//       if (data?.status === 'success' && Array.isArray(data.data)) {
//         setNotes(data.data);
//       } else {
//         console.error('Invalid response format:', data);
//         setNotes([]);
//       }
//     } catch (error) {
//       console.error('Error fetching notes:', error);
//       setNotes([]);
//     }
//   };

//   const createNote = async () => {
//     if (!newNote.trim()) {
//       alert('Please enter a note before submitting.');
//       return;
//     }
//     try {
//       await fetch('https://salesjet-10097049716.catalystappsail.com/leadsnotes', {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${accessToken}`,
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           LeadACVLRecordID: LeadId,
//           LeadNotes: newNote,
//           Userfirstname: userDetails.firstName,
//           NotesTimeStamp: new Date().toISOString(),
//         }),
//       });
//       setNewNote('');
//       fetchNotes();
//     } catch (error) {
//       console.error('Error creating note:', error);
//     }
//   };
//   const formatDate = (isoString) => {
//     const date = new Date(isoString);
//     return `Date: ${date.toISOString().split('T')[0]} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
//   };

//   return (
//     <div style={{padding:'10px'}}>
//         <h5 style={{margin:'2px'}}>New Note</h5>
//         <textarea
//             placeholder="Enter new note..."
//             value={newNote}
//             onChange={(e) => setNewNote(e.target.value)}
//         />
//         <button onClick={createNote}>Add Note</button>
//         {notes.map((note) => (
//       <div key={note.ROWID} style={{ marginBottom: '10px' }}>
//         <p>Agent Name:{note.Userfirstname}  {formatDate(note.NotesTimeStamp)}</p>
//         <textarea readOnly>{note.LeadNotes}</textarea>
//       </div>
//     ))}
//     </div>
//   );
// };

// export default Notes;

// // // // old one 


// // // // // // // after the Notes flag change on 12/09/2025

// import React, { useState, useEffect } from 'react';

// const Notes = ({ notes: initialNotes, refetchNotes, LeadId, accessToken, userDetails , rowId }) => {
//   const [notes, setNotes] = useState(initialNotes || []);
//   const [newNote, setNewNote] = useState('');
//   const [category, setCategory] = useState('');
//   const [details, setDetails] = useState('');

//   useEffect(() => {
//     setNotes(initialNotes || []);
//   }, [initialNotes]);

//   const createNote = async () => {
//     if (!newNote.trim() || !category.trim() || !details.trim()) {
//       alert('Please fill all fields before submitting.');
//       return;
//     }

//     try {
//       await fetch(
//         'https://salesjet-10097049716.catalystappsail.com/leadsnotes',
//         {
//           method: 'POST',
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({
//             LeadACVLRecordID: LeadId,
//             LeadNotes: newNote,
//             Category: category,
//             Category_Details: details,
//             Userfirstname: userDetails.firstName,
//             NotesTimeStamp: new Date().toISOString(),
//           }),
//         }
//       );

//       // Additional PUT request for Next Follow-up
//       if (category.toLowerCase() === 'next follow-up' && rowId) {
//         const updatedData = [{ ROWID: rowId, FollowUpDate: details }];
//         await fetch(
//           'https://salesjet-10097049716.catalystappsail.com/leadsdata',
//           {
//             method: 'PUT',
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               'Content-Type': 'application/json',
//             },
//             body: JSON.stringify(updatedData),
//           }
//         );
//       }
//       setNewNote('');
//       setCategory('');
//       setDetails('');
//       if (refetchNotes) {
//         refetchNotes();
//       }
//     } catch (error) {
//       console.error('Error creating note:', error);
//     }
//   };

//   const formatDate = (isoString) => {
//     const date = new Date(isoString);
//     return `Date: ${date.toISOString().split('T')[0]} ${date
//       .getHours()
//       .toString()
//       .padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
//   };

//   return (
//     <div style={{ padding: '10px' }}>
//       <h4 style={{ margin: '2px', padding: '5px', borderBottom: '1px solid' }}>Create New Note</h4>

//       {/* Category Dropdown */}
//       <div className="lead-section-content">
//         {/* Category field with type-in + dropdown */}
//         <div className="editable-field">
//           <label>Category</label>
//           <div className="input-container">
//             <input
//               list="categoryOptions"
//               placeholder="Select or type category..."
//               value={category}
//               onChange={(e) => {
//                 setCategory(e.target.value);
//                 setDetails(''); 
//               }}
//               style={{ display: 'block', marginBottom: '10px', width: '100%' }}
//             />
//             <datalist id="categoryOptions">
//               <option value="Prospective" />
//               <option value="Next Follow-up" />
//               <option value="Connection Status" />
//             </datalist>
//           </div>
//         </div>

//         <div className="editable-field">
//           <label>Category Details</label>
//           <div className="input-container">
//             {category === 'Prospective' ? (
//               <select
//                 value={details}
//                 onChange={(e) => setDetails(e.target.value)}
//                 style={{ display: 'block', marginBottom: '10px' }}
//               >
//                 <option value="">-- Select --</option>
//                 <option value="Warm">Warm</option>
//                 <option value="Cold">Cold</option>
//                 <option value="Hot">Hot</option>
//               </select>
//             ) : category === 'Connection Status' ? (
//               <select
//                 value={details}
//                 onChange={(e) => setDetails(e.target.value)}
//                 style={{ display: 'block', marginBottom: '10px' }}
//               >
//                 <option value="">-- Select --</option>
//                 <option value="Connected">Connected</option>
//                 <option value="Not Connected">Not Connected</option>
//               </select>
//             ) : category === 'Next Follow-up' ? (
//               <input
//                 type="date"
//                 value={details}
//                 onChange={(e) => setDetails(e.target.value)}
//                 style={{ display: 'block', marginBottom: '10px' }}
//               />
//             ) : (
//               <input
//                 type="text"
//                 placeholder="Enter details..."
//                 value={details}
//                 onChange={(e) => setDetails(e.target.value)}
//                 style={{ display: 'block', marginBottom: '10px', width: '100%' }}
//               />
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Notes Textarea */}
//       <label>Note:</label>
//       <textarea
//         placeholder="Enter new note..."
//         value={newNote}
//         onChange={(e) => setNewNote(e.target.value)}
//         style={{ display: 'block', marginBottom: '10px', width: '100%' }}
//       />

//       <button onClick={createNote}>Add Note</button>

//       {/* Show Notes */}
//       {/* {notes.map((note) => (
//         <div
//           key={note.ROWID}
//           style={{
//             marginBottom: '10px',
//             border: '1px solid #ddd',
//             padding: '5px',
//           }}
//         >
//           <p>
//             <strong>Agent:</strong> {note.Userfirstname} <br />
//             <strong>{formatDate(note.NotesTimeStamp)}</strong>
//           </p>
//           <p>
//             <strong>Category:</strong> {note.Category || 'N/A'}
//           </p>
//           <p>
//             <strong>Details:</strong> {note.Category_Details || 'N/A'}
//           </p>
//           <textarea readOnly style={{ width: '100%' }}>
//             {note.LeadNotes}
//           </textarea>
//         </div>
//       ))} */}
//       {notes.map((note) => (
//         <div
//           key={note.ROWID}
//           style={{
//             marginBottom: '10px',
//             border: '1px solid #ddd',
//             padding: '5px',
//           }}
//         >
//           <textarea readOnly style={{ width: '100%', marginBottom: '5px' }}>
//             {note.LeadNotes}
//           </textarea>
//           <div
//             style={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center',
//               fontSize: '0.85em', // Smaller text size
//               color: '#555', // Optional: slightly muted color for small text
//             }}
//           >
//             <div>
//               <strong>Category:</strong> {note.Category || 'N/A'} |{' '}
//               <strong>Details:</strong> {note.Category_Details || 'N/A'}
//             </div>
//             <div>
//               <strong>Agent:</strong> {note.Userfirstname} |{' '}
//               <strong>{formatDate(note.NotesTimeStamp)}</strong>
//             </div>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default Notes;

import React, { useState, useEffect } from 'react';

const Notes = ({ notes: initialNotes, refetchNotes, LeadId, updateLeadData, accessToken, userDetails, rowId }) => {
  const [notes, setNotes] = useState(initialNotes || []);
  const [newNote, setNewNote] = useState('');
  const [category, setCategory] = useState('');
  const [details, setDetails] = useState('');

  useEffect(() => {
    setNotes(initialNotes || []);
  }, [initialNotes]);

  const createNote = async () => {
    if (!newNote.trim() || !category.trim() || !details.trim()) {
      alert('Please fill all fields before submitting.');
      return;
    }

    try {
      // Create the note
      const notePayload = {
        LeadACVLRecordID: LeadId,
        LeadNotes: newNote,
        Category: category,
        Category_Details: details,
        Userfirstname: userDetails.firstName,
        NotesTimeStamp: new Date().toISOString(),
      };
      const noteResponse = await fetch('https://salesjet-10097049716.catalystappsail.com/leadsnotes', {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(notePayload),
      });
      console.log('Note creation response:', noteResponse.ok, await noteResponse.json());

      // If category is 'Next Follow-up', update FollowUpDate
      if (category.toLowerCase() === 'next follow-up' && rowId) {
        const updatedData = [{ ROWID: rowId, FollowUpDate: details }];
        const updateResponse = await fetch('https://salesjet-10097049716.catalystappsail.com/leadsdata', {
          method: 'PUT',
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(updatedData),
        });
        console.log('FollowUpDate update response:', updateResponse.ok, await updateResponse.json());

        // Update the lead data with the new FollowUpDate
        const updatedBooking = {
          LeadACVLRecordID: LeadId,
          ROWID: rowId,
          FollowUpDate: details,
        };
        // console.log('Calling updateLeadData with:', updatedBooking);
        updateLeadData(updatedBooking);
      }

      setNewNote('');
      setCategory('');
      setDetails('');
      if (refetchNotes) {
        console.log('Calling refetchNotes');
        refetchNotes();
      }
    } catch (error) {
      console.error('Error creating note or updating FollowUpDate:', error);
    }
  };

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return `Date: ${date.toISOString().split('T')[0]} ${date
      .getHours()
      .toString()
      .padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
  };

  return (
    <div style={{ padding: '10px' }}>
      <div style={{border:'1px solid #333', borderRadius:'10px'}}>
        <h4 style={{ margin: '2px', padding: '5px', borderBottom: '1px solid #333' }}>Create New Note</h4>
        <div className="lead-section-content">
          <div className="editable-field">
            <label>Category</label>
            <div className="input-container">
              <input
                list="categoryOptions"
                placeholder="Select or type category..."
                value={category}
                onChange={(e) => {
                  setCategory(e.target.value);
                  setDetails('');
                }}
                style={{ display: 'block', marginBottom: '10px', width: '100%' }}
              />
              <datalist id="categoryOptions">
                <option value="Prospective"/>
                <option value="Next Follow-up"/>
                <option value="Connection Status"/>
              </datalist>
            </div>
          </div>
          <div className="editable-field">
            <label>Category Details</label>
            <div className="input-container">
              {category === 'Prospective' ? (
                <select
                  value={details}
                  onChange={(e) => setDetails(e.target.value)}
                  style={{ display: 'block', marginBottom: '10px' }}
                >
                  <option value="">-- Select --</option>
                  <option value="Warm">Warm</option>
                  <option value="Cold">Cold</option>
                  <option value="Hot">Hot</option>
                </select>
              ) : category === 'Connection Status' ? (
                <select
                  value={details}
                  onChange={(e) => setDetails(e.target.value)}
                  style={{ display: 'block', marginBottom: '10px' }}
                >
                  <option value="">-- Select --</option>
                  <option value="Connected">Connected</option>
                  <option value="Not Connected">Not Connected</option>
                </select>
              ) : category === 'Next Follow-up' ? (
                <input
                  type="datetime-local"
                  value={details}
                  onChange={(e) => setDetails(e.target.value)}
                  min={new Date().toISOString().slice(0, 16)}
                  style={{ display: 'block', marginBottom: '10px' }}
                />
              ) : (
                <input
                  type="text"
                  placeholder="Enter details..."
                  value={details}
                  onChange={(e) => setDetails(e.target.value)}
                  style={{ display: 'block', marginBottom: '10px', width: '100%' }}
                />
              )}
            </div>
          </div>
        </div>
        <div style={{ padding: '0 10px' }}>
          <label>Note:</label>
          <textarea
            placeholder="Enter new note..."
            value={newNote}
            onChange={(e) => setNewNote(e.target.value)}
            style={{ display: 'block', marginBottom: '10px', width: '100%' }}
          />
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <button onClick={createNote} style={{
              padding: '5px 10px',
              background: 'gray',
              color: 'rgb(255, 255, 255)',
              borderRadius: '10px'
            }}>Add Note</button>
          </div>
        </div>
      </div>
      {notes.map((note) => (
        <div
          key={note.ROWID}
          style={{ margin: '10px', border: '1px solid #ddd', padding: '5px' }}
        >
          <textarea
            readOnly
            style={{ width: '100%', marginBottom: '5px', border: 'none'}}
            value={note.LeadNotes}
          />
          <div
            style={{
              borderTop: '1px solid #ddd',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              fontSize: '0.85em',
              color: '#555',
            }}
          >
            <div>
              <strong>Category:</strong> {note.Category || 'N/A'} |{' '}
              <strong>Details:</strong> {note.Category_Details || 'N/A'}
            </div>
            <div>
              <strong>Agent:</strong> {note.Userfirstname} |{' '}
              <strong>{formatDate(note.NotesTimeStamp)}</strong>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Notes;